/**
 * Navigation entre vues sans routeur : un écran demande l'ouverture d'un
 * onglet de Réglages (« Ouvrir le canal de test » depuis le Studio ou
 * l'onglet Diffusion), `AppLayout` l'exécute.
 */
export const OPEN_SETTINGS_TAB_EVENT = 'trafficplay:open-settings-tab'

export interface OpenSettingsTabDetail {
  tab: string
}

export function openSettingsTab(tab: string): void {
  window.dispatchEvent(new CustomEvent<OpenSettingsTabDetail>(OPEN_SETTINGS_TAB_EVENT, { detail: { tab } }))
}
